import Element from '../../../core/Element';
import type { Theme } from '../../../core/types';
import { BackgroundImage } from '../../atoms/background-image';
import { Container } from '../../atoms/grid';
import { useBreakpoint } from '../../styleless/breakpoint';
import styles from './index.module.less';

interface HeroBannerProps {
  data: {
    image: {
      _default: string;
      sm?: string;
      md?: string;
      lg?: string;
    };
  };
  $backgroundSize?: string;
  $backgroundRepeat?:
    | 'repeat'
    | 'repeat-x'
    | 'repeat-y'
    | 'no-repeat'
    | 'inherit';
  $withGradient: 'light' | 'dark';
  children: React.ReactNode;
  $withChildrenStyle?: boolean;
  customization?: {
    container?: Theme;
    imageHeight?: string;
  };
  qeId?: string;
}

export const HeroBanner = ({
  data: { image },
  children,
  $backgroundSize,
  $backgroundRepeat,
  $withChildrenStyle = true,
  customization = {},
  $withGradient,
  qeId = 'HeroBanner',
}: HeroBannerProps) => {
  const { current, sm } = useBreakpoint();
  return (
    <BackgroundImage
      qeId={qeId}
      imageUrl={image[current] || image._default}
      $withGradient={$withGradient}
      $backgroundSize={$backgroundSize}
      $backgroundRepeat={$backgroundRepeat}
      height={customization?.imageHeight || (sm ? 150 : 270)}
    >
      {$withChildrenStyle ? (
        <Element className={styles.content} theme={{ verticallyFluid: true }}>
          <Container theme={{ ...(customization?.container || {}) }}>
            {children}
          </Container>
        </Element>
      ) : (
        children
      )}
    </BackgroundImage>
  );
};
